import React, { useState } from 'react';
import styled from 'styled-components';
import BlogImg02 from '../assets/blog/future-of-smart-home.png';
import BlogImg03 from '../assets/blog/battery.png';
import BlogImg05 from '../assets/blog/fix-wifi.png';

const relatedPosts = [
  {
    slug: 'the-future-of-smart-homes',
    title: 'The Future of Smart Homes: What You Need to Know',
    img: BlogImg02,
  },
  {
    slug: 'why-battery-life-is-a-challenge-for-wireless-security-cameras',
    title: 'Why Battery Life Is a Challenge for Wireless Security Cameras',
    img: BlogImg03,
  },
  {
    slug: 'why-your-security-camera-wont-connect-to-wifi',
    title: "Why Your Security Camera Won't Connect to Wi-Fi — And How to Fix It",
    img: BlogImg05,
  },
];

const Section = styled.section`
  margin: 80px auto 0 auto;
  max-width: 1200px;
  text-align: center;
`;

const Title = styled.h2`
  color: #F87B15;
  font-size: 2.3rem;
  font-weight: 800;
  margin-bottom: 1.2rem;
  line-height: 1.25;
`;

const CardsRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
  justify-content: center;
  @media (min-width: 900px) {
    flex-direction: row;
    gap: 2.5rem;
  }
`;

const Card = styled.a`
  background: #fff;
  border-radius: 32px;
  border: 2px solid #e5e7eb;
  overflow: hidden;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.03);
  text-decoration: none;
  color: inherit;
  transition: box-shadow 0.2s, border 0.2s;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  &:hover {
    box-shadow: 0 4px 24px rgba(248,123,21,0.10);
    border: 2px solid #F87B15;
  }
`;

const CardImg = styled.img`
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 32px 32px 0 0;
`;

const CardContent = styled.div`
  padding: 1.25rem 1.25rem 1.5rem 1.25rem;
  text-align: left;
`;

const CardTitle = styled.h3`
  font-size: 1.15rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  line-height: 1.35;
`;

const CardMeta = styled.p`
  font-size: 1rem;
  color: #222;
  margin-top: 0.5rem;
  span {
    font-weight: 700;
  }
`;

const ReadMoreBtn = styled.button`
  margin: 2.5rem auto 0 auto;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #fff;
  border: 2px solid #F87B15;
  color: #F87B15;
  font-size: 1.25rem;
  font-weight: 600;
  border-radius: 2.5rem;
  padding: 0.75rem 2.25rem;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  &:hover {
    background: #F87B15;
    color: #fff;
  }
`;

export default function RelatedBolg({ currentSlug }: { currentSlug: string }) {
  const [showAll, setShowAll] = useState(false);
  const filtered = relatedPosts.filter(post => post.slug !== currentSlug);
  const visiblePosts = showAll ? filtered : filtered.slice(0, 3);
  const hasMore = filtered.length > 3 && !showAll;

  return (
    <Section>
      <Title>Related Posts</Title>
      <CardsRow>
        {visiblePosts.map(post => (
          <Card href={`/${post.slug}`} key={post.slug}>
            <CardImg src={post.img} alt={post.title} />
            <CardContent>
              <CardTitle>{post.title}</CardTitle>
              <CardMeta>By <span>Sensforge Team</span></CardMeta>
            </CardContent>
          </Card>
        ))}
      </CardsRow>
      {hasMore && (
        <ReadMoreBtn onClick={() => setShowAll(true)}>
          <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 5v14m0 0l-5-5m5 5l5-5" stroke="#F87B15" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
            Read More
          </span>
        </ReadMoreBtn>
      )}
    </Section>
  );
}

